<template>
  <el-dialog v-model="dialogFormVisible" :title="title" width="500px" @close="close">
    <el-tag style="margin-bottom: 20px" type="danger">* 渠道编辑不改变渠道唯一key值,只对名称和备注进行修改</el-tag>
    <el-form ref="formRef" label-width="80px" :model="form" :rules="rules">
      <el-form-item label="身份" prop="identity">
        <el-select v-model="form.identity" clearable :disabled="title === '编辑'" placeholder="请选择身份">
          <el-option v-for="item in identityOptions" :key="item.value" v-bind="item" />
        </el-select>
      </el-form-item>
      <el-form-item label="渠道名称" prop="channelName">
        <el-input v-model.trim="form.channelName" clearable />
      </el-form-item>
      <el-form-item label="渠道备注" prop="remarks">
        <el-input v-model.trim="form.remarks" clearable type="textarea" />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="save">确 定</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { defineComponent, getCurrentInstance, reactive, toRefs, computed } from 'vue'
import { doEdit, doAdd, _importChannelAddChannel, _importChannelUpdateChannel } from '@/api/channel'
import { getIdentityOptions } from '@/api/exhibitionManage'

// 引入下拉数选择
export default defineComponent({
  name: 'UserManagementEdit',
  components: {},
  props: {
    eventId: {
      type: String,
      default: '',
    },
    meetType: {
      type: String,
      default: '',
    },
    isUser: {
      type: Boolean,
      default: false,
    },
    identityOptions: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['fetch-data'],
  setup(props, { emit }) {
    const { proxy } = getCurrentInstance()
    // 自定义手机验证

    const state = reactive({
      formRef: null,
      form: {
        appKey: 'WX_MINI_WEMEET',
      },
      departmentData: [],
      title: '',
      dialogFormVisible: false,
      roleList: [],
      wcs: [],
    })

    const rules = computed(() => {
      return {
        channelName: [{ required: true, trigger: 'blur', message: '请输入渠道名称' }],
        remarks: [{ required: true, trigger: 'blur', message: '请输入渠道备注' }],
        appKey: [{ required: true, trigger: 'change', message: '请选择appKey' }],
        identity: [{ required: state.title === '添加', trigger: 'change', message: '请选择身份' }],
      }
    })

    const showEdit = async (row) => {
      const { wcs } = JSON.parse(localStorage.getItem('customInfo'))
      state.wcs = wcs
      if (!row) {
        state.title = '添加'
      } else {
        state.title = '编辑'
        state.form = Object.assign({}, row)
      }
      state.dialogFormVisible = true
    }
    const close = () => {
      state.dialogFormVisible = false
      state.form = {
        appKey: 'WX_MINI_WEMEET',
      }
      state['formRef'].resetFields()
    }
    const save = () => {
      state['formRef'].validate(async (valid) => {
        if (valid) {
          state.form.meetingCode = props.eventId
          state.form.type = props.meetType
          if (state.wcs?.[0]?.appKey) state.form.appKey = state.wcs[0].appKey

          if (props.isUser) {
            if (state.title == '添加') {
              await _importChannelAddChannel(state.form)
            } else {
              await _importChannelUpdateChannel(state.form)
            }
          } else {
            if (state.title == '添加') {
              await doAdd(state.form)
            } else {
              await doEdit(state.form)
            }
          }

          proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
          emit('fetch-data')
          close()
        }
      })
    }

    return {
      ...toRefs(state),
      showEdit,
      close,
      save,
      rules,
    }
  },
})
</script>
